import axios from 'axios';
import API_HOST from 'consts';

export default axios.create({
  baseURL: API_HOST,
});
